import { Moon, Sun } from 'lucide-react';
import '../AllCss/ThemeToggleSwitch.css';

function ThemeToggleSwitch({ isDark, onToggle }) {
  const handleToggle = (e) => {
    e.stopPropagation();
    onToggle();
  };

  return (
    <div className="theme-toggle-switch-container">
      <div className="theme-toggle-label">
        {isDark ? <Sun size={16} /> : <Moon size={16} />}
        <span>Dark Mode</span>
      </div>
      <button
        type="button"
        className={`theme-toggle-switch ${isDark ? 'active' : ''}`}
        onClick={handleToggle}
        aria-label={isDark ? 'Use light menu' : 'Use dark menu'}
        role="switch"
        aria-checked={isDark}
      >
        <span className="theme-toggle-slider"></span>
      </button>
    </div>
  );
}

export default ThemeToggleSwitch;
